import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Technician } from '../../../shared/model/technician';
import { TechnicianService } from '../../../shared/service/technician.service';
import { FindHttpError } from '../../../shared/error/find-http-error';
import { UPDATE_TECHNICIAN_FILTER } from '../../../core/actions';
import { ArgosState } from '../../../core/argos-state';
import { Mask } from '../../../shared/pipe/interface/mask';
import { CpfPipe } from '../../../shared/pipe/cpf.pipe';
import { NgRedux } from '@angular-redux/store';
import { TechnicianFilter } from '../../../shared/filter/technician-filter';
import { Observable } from 'rxjs/Observable';
import { PageInfo } from '../../../shared/model/page-info';
import { ToastService } from '../../../shared/service/toast.service';

declare var Materialize: any;

@Component({
  selector: 'tx-technician-list',
  templateUrl: './technician-list.component.html',
  styleUrls: ['./technician-list.component.css']
})
export class TechnicianListComponent implements OnInit {
  technicians: Array<Technician>;
  pageNumber = 0;
  pageSize = 15;
  pageInfo: PageInfo;
  nextDisabled = false;
  cpfMask = new CpfPipe();

  filterField = ['technicianFilter'];
  cpfFilter = ['cpf'];
  nameFilter = ['name'];
  autoEletricNameFilter = ['autoEletricName'];
  rgFilter = ['rg'];
  filter = [];
  filterIsOpened = false;
  filterLabel = '';
  mask: Mask;
  maxChar: number;
  filterActionType = UPDATE_TECHNICIAN_FILTER;
  inputTypeFilter = 'text';
  technicianFilter$: Observable<any>;

  constructor(private _router: Router,
              private _technicianService: TechnicianService,
              private _ngRedux: NgRedux<ArgosState>,
              private _toastService: ToastService) {
    this.technicians = new Array();
    this.findTechnicians();
    this.setUpObservers();
  }

  ngOnInit() {
  }

  setUpObservers() {
    this.technicianFilter$ = this._ngRedux.select('technicianFilter');
    this.setUpFindAction(this._technicianService.find$);
    this.setUpErrorAction(this._technicianService.error$);
    this.setUpDisableAction(this._technicianService.delete$);
    this.setUpPageInfo(this._technicianService.pageInfo$);
  }

  newTechnician() {
    this._router.navigate([`technicians`]);
  }

  editTechnician(id) {
    this._router.navigate([`technicians/${id}`]);
  }

  deleteTechnician(id) {
    this._technicianService.disable(id);
  }

  findTechnicians() {
    this._technicianService.findTechnicians(this.pageNumber, this.pageSize);
  }

  findByFilter(pageNumber?: number) {
    this.pageNumber = pageNumber || 0;
    this.filterIsOpened = false;
    this.findTechnicians();
  }

  openFilter(inputType, label, filterField, mask?, maxChar?) {
    if (filterField[filterField.length - 1] === this.filter[this.filter.length - 1] && this.filterIsOpened) {
      this.filterIsOpened = false;
    } else {
      this.maxChar = maxChar;
      this.mask = mask;
      this.filter = this.filterField.concat(filterField);
      this.filterIsOpened = true;
      this.inputTypeFilter = inputType;
      this.filterLabel = label;
    }
  }

  goToPage(pageNumber) {
    this.pageNumber = pageNumber > 0 ? pageNumber - 1 : pageNumber;
    this.findTechnicians();
  }

  previousPage() {
    if (this.pageNumber > 0) {
      this.pageNumber = this.pageNumber - 1;
      this.findTechnicians();
    }
  }

  nextPage() {
    if (this.pageNumber < this.pageInfo.lastPage - 1) {
      this.pageNumber = this.pageNumber + 1;
      this.findTechnicians();
    }
  }

  private showMessage(message: string) {
    this._toastService.showMessage(message, 4000);
  }

  private setUpFindAction(observable) {
    observable
      .filter(technicians => technicians instanceof Array)
      .subscribe((technicians: Array<Technician>) => {
          this.technicians = technicians;
      });
  }

  private setUpErrorAction(observable) {
    observable
      .filter(error => error instanceof FindHttpError)
      .subscribe((error) => {
        this.showMessage(error.text);
      });
  }

  private setUpDisableAction(observable) {
    observable
      .subscribe(technicianId => this.findByFilter(this.pageNumber));
  }

  private setUpPageInfo(observable) {
    observable
      .subscribe(pageInfo => this.pageInfo = pageInfo);
  }

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/technician/component/technician-list/technician-list.component.ts